import { Injectable } from '@angular/core';

import { ApiService }            from '../../app-lite/api/api.service';
import { CodeTypeModel }         from '../../app-lite/core/models/code-type';
import { InitialUserSetupModel } from './typings/user.initial-setup';
import { UserSignUpModel }       from './typings/user.sign-up';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor (
    private apiService: ApiService
  ) {}

  getCountries () : Promise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/country_types', null, null, {
      bypass: true
    });
  }

  saveInitialSetup ( userSubscription : InitialUserSetupModel ) : Promise<any> {
    return this.apiService.post('/subscriptions/first_user_setup', userSubscription);
  }

  signUp ( user : UserSignUpModel ) : Promise<any> {
    return this.apiService.post('/subscriptions/capricorn_setup', user);
  }

  verifySubscription ( customerId : string, subscriptionId : string ) : Promise<any> {
    return this.apiService.get('/subscriptions/verify_chargify_subscription', [ customerId, subscriptionId ]);
  }
}
